import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { t } from 'i18next';

import { ShareBaseTab } from './ShareBaseTab';
import { AppDispatcher } from '../../dispatcher/AppDispatcher';
import { ProjectManagerStore } from '../../stores/ProjectManagerStore';
import { CustomStore } from '../../stores/CustomStore';
import { UIHelper } from '../../utils/UIHelper';
import { ReCAPTCHA } from '../ReCAPTCHA';
import { ActionConstants } from '../../constants/ActionConstants';
import { SidebarModule } from '../../constants/Enums';
import { SidebarHeader } from '../SidebarHeader';
import { CustomRadioGroup } from '../CustomRadioGroup';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { DownloadHelper } from '../../utils/DownloadHelper';
import { UrlHelper } from '../../utils/UrlHelper';
import { PDFMaker } from '../../utils/PDFMaker';
import { FileFormats, FileFormatInfo } from '../../constants/FileFormat';
import { InputBox } from '../InputBox';
import { InputCheckBox } from '../InputCheckBox';
import { DesktopSelect } from '../DesktopSelect';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { ArticleActions } from '../../actions/ArticleActions';
import { UICoreButton } from '../UICoreButton';
import { MailPlugin, Message } from '../../utils/webservices/MailPlugin';
import { Stats } from '../../utils/Stats';
import { LoadingCancelable } from '../LoadingCancelable';
import { getEnvVar } from '../../submodules/utils/ReactScriptHelper';
import { CustomCheckRadioGroup } from '../CustomCheckRadioGroup';

import utils = egr.wcf.utils;

const recaptchaSitekey: string = getEnvVar('RECAPTCHA_SITEKEY', '');

const enum FormularItemType {
    HIDDEN = 0,
    TEXT = 1,
    CHECK = 2,
    MULTILINE = 3,
    SELECT = 4,
    CHECKRADIO = 5,
    CHECKRADIOGROUP = 6,
}

interface FormularItem {
    label: string;
    labelManufacturerMail: string;
    type: FormularItemType;
    required: boolean;
    key: string;
    defaultValue: any;
    name?: string;
    values?: Array<{ label: string, value: string }>;
    cleverreachName: string | null;
}

interface CustomShareFormularState {
    valid: boolean;
    step: number;
    choice: number;
    token: string | undefined;
}

export class CustomShareFormular extends ShareBaseTab<CustomShareFormularState> {
    protected values: { [key: string]: string | number | boolean } = {};
    protected config: { [key: string]: FormularItem } = {
        // tslint:disable-next-line:max-line-length
        company: { type: FormularItemType.TEXT, label: 'Company', labelManufacturerMail: 'Firma', required: false, key: 'company', defaultValue: null, cleverreachName: '1116829' },
        // tslint:disable-next-line:max-line-length
        retailer: { type: FormularItemType.TEXT, label: 'Specialist retailer attending customer', labelManufacturerMail: 'Betreuender Fachh├ñndler', required: false, key: 'retailer', defaultValue: null, cleverreachName: '1116841' },
        // tslint:disable-next-line:max-line-length
        name: { type: FormularItemType.TEXT, label: 'Name', labelManufacturerMail: 'Name', required: false, key: 'name', defaultValue: null, cleverreachName: '1116830' },
        // tslint:disable-next-line:max-line-length
        email: { type: FormularItemType.TEXT, label: 'E-Mail', labelManufacturerMail: 'E-Mail', required: true, key: 'email', defaultValue: null, cleverreachName: 'email' },
        // tslint:disable-next-line:max-line-length
        phone: { type: FormularItemType.TEXT, label: 'Phone', labelManufacturerMail: 'Telefon', required: false, key: 'phone', defaultValue: null, cleverreachName: '1116831' },
        // tslint:disable-next-line:max-line-length
        street: { type: FormularItemType.TEXT, label: 'Street', labelManufacturerMail: 'Stra├ƒe', required: false, key: 'street', defaultValue: null, cleverreachName: '1116832' },
        // tslint:disable-next-line:max-line-length
        postalcode: { type: FormularItemType.TEXT, label: 'Postal code', labelManufacturerMail: 'PLZ', required: false, key: 'postalcode', defaultValue: null, cleverreachName: '1116833' },
        // tslint:disable-next-line:max-line-length
        city: { type: FormularItemType.TEXT, label: 'Town/city', labelManufacturerMail: 'Ort', required: false, key: 'city', defaultValue: null, cleverreachName: '1116834' },
        // tslint:disable-next-line:max-line-length
        country: { type: FormularItemType.TEXT, label: 'Country', labelManufacturerMail: 'Land', required: false, key: 'country', defaultValue: null, cleverreachName: '1116835' },
        // tslint:disable-next-line:max-line-length
        sector: { type: FormularItemType.TEXT, label: 'Sector', labelManufacturerMail: 'Branche', required: false, key: 'sector', defaultValue: null, cleverreachName: '1116836' },
        // tslint:disable-next-line:max-line-length
        message: { type: FormularItemType.MULTILINE, label: 'Message', labelManufacturerMail: 'Nachricht', required: false, key: 'message', defaultValue: null, cleverreachName: null },
        'information-by': {
            type: FormularItemType.CHECKRADIOGROUP,
            label: 'I give my consent to receiving more information from B.PRO',
            labelManufacturerMail: 'Ich bin einverstanden, weitere Informationen von B.PRO zu erhalten',
            required: false,
            key: 'information-by',
            defaultValue: 'By e-mail and by phone',
            values: [
                { label: 'By e-mail', value: 'By e-mail' },
                { label: 'By phone', value: 'By phone' },
                { label: 'By e-mail and by phone', value: 'By e-mail and by phone' },
            ],
            cleverreachName: '1138233',
        },
        'i-am-a': {
            type: FormularItemType.CHECKRADIOGROUP,
            label: 'I am a',
            labelManufacturerMail: 'Ich bin',
            required: false,
            key: 'i-am-a',
            defaultValue: null,
            values: [
                { label: 'Specialist dealer', value: 'Specialist dealer' },
                { label: 'End user', value: 'End user' }
            ],
            cleverreachName: '1116837',
        },
    };
    protected choices: Array<string> = [
        'I\'d like to receive more product information',
        'I\'d like to receive a quote and/or consultation',
        'I\'d like to receive more product information and a quote/consultation'
    ];
    protected recaptcha: ReCAPTCHA | null;

    public componentWillMount(): void {
        this.values = CustomStore.getCustomState('shareformular');
        this.validate();
        this.setState(jQuery.extend({}, this.state, {
            choice: 0,
            step: 1
        }));
    }

    public componentWillUnmount(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SAVE_DATA,
            value: {
                key: 'shareformular',
                payload: this.values
            }
        });
    }

    public componentDidMount(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
        }
    }

    public componentDidUpdate(): void {
        if (this.props.visible) {
            UIHelper.updateScrollbar(ReactDOM.findDOMNode(this) as Element);
        }
    }
    public render(): JSX.Element | null {
        if (!this.props.visible) {
            return null;
        }
        if (this.state.step === 2) {
            return (
                <div className="sidebar-tab-container" key={'mail-form-tab-' + this.props.layoutType.toString()}><div className="scrollbar-wcf">
                    <div className="sidebar-content standard-header custom-share-formular-step-2">
                        <SidebarHeader
                            headerCallback={this.firstStep}
                            leftArrow={true}
                            text={t('Contact request')}
                        />
                        {this.elements()}
                        <div
                            className="custom-hint"
                            dangerouslySetInnerHTML={{
                                // tslint:disable-next-line:max-line-length
                                __html: t('You will find the data privacy policy for the configurator <a href="https://www.bpro-solutions.com/en/service/imprint.cfm" target="_blank">here</a>. We have compiled information as per Art. 13 GDPR for you <a href="https://www.bpro-solutions.com/data_privacy" target="_blank">here</a>.', {
                                    interpolation: { escapeValue: false }
                                })
                            }}
                        />
                        {this.state.choice > 0 &&
                            <div className="custom-hint">{t('Our specialised consultant will contact you shortly.')}</div>}
                        <ReCAPTCHA
                            callback={this.onRecaptchaChange}
                            ref={(node) => this.recaptcha = node}
                            sitekey={recaptchaSitekey}
                        />
                        {this.button()}
                        <div className="required-info">{'* ' + t('required')}</div>
                    </div>
                </div></div>
            );
        }
        return (
            <div className="sidebar-tab-container">
                <div className="scrollbar-wcf">
                    <SidebarHeader
                        headerCallback={this.openShareMail}
                        leftArrow={true}
                        text={t('Contact request')}
                    />
                    <div className="sidebar-content standard-header custom-sidebar-content">
                        <CustomRadioGroup
                            values={this.choices.map((label: string, index: number) => {
                                return { label: t(label), value: index.toString() };
                            })}
                            defaultValue={this.state.choice.toString()}
                            onChange={this.setChoice}
                        />
                        <UICoreButton
                            color="green"
                            align="block"
                            onClick={this.nextStep}
                            label={t('Next')}
                        />
                    </div>
                </div>
            </div>
        );
    }

    protected button = (): JSX.Element => {
        if (this.state.valid && utils.string.isNotNullOrEmpty(this.state.token)) {
            return (
                <button className="core-button core-button-green core-button-block" onClick={this.submit}>{t('Send')}</button>
            );
        }
        return (
            <button className="core-button core-button-light-grey core-button-block" disabled={true}>{t('Send')}</button>
        );
    };

    protected setValue(value: string | number | boolean, key: string, forceUpdate?: boolean): void {
        this.values[key] = value;
        this.validate(forceUpdate);
    }

    protected onChangeValue = (key: string, forceUpdate?: boolean) => (value) => {
        this.setValue(value, key, forceUpdate);
    };

    protected onChangeValueForCheckbox = (key: string, forceUpdate?: boolean) => () => {
        this.setValue(this.values[key] == null || this.values[key] === false, key, forceUpdate);
    };

    protected validate(forceUpdate?: boolean): void {
        let valid: boolean = true;
        Object.keys(this.config).forEach((key) => {
            if (this.config[key].required && !this.values[key]) {
                valid = false;
                return;
            }
        });
        if (this.state == null || this.state.valid !== valid || forceUpdate) {
            this.setState(jQuery.extend({}, this.state, {
                valid: valid
            }));
        }
    }

    protected elements = (): Array<JSX.Element> => {
        const result: Array<JSX.Element> = [];
        Object.keys(this.config).map((key: string, index: number) => {
            const item: FormularItem = this.config[key];
            switch (item.type) {
                case FormularItemType.TEXT:
                    result.push(
                        <InputBox
                            placeholder={t(item.label) + (item.required ? ' *' : '')}
                            className="mail-input"
                            key={index.toString() + '-item'}
                            ref={item.key}
                            changeCallback={this.onChangeValue(item.key)}
                            defaultValue={this.values[item.key] != null ? this.values[item.key] : item.defaultValue}
                            name={item.name}
                            position="input-container-sidebartab"
                        />
                    );
                    break;
                case FormularItemType.MULTILINE:
                    result.push(
                        <InputBox
                            placeholder={t(item.label) + (item.required ? ' *' : '')}
                            className="mail-input"
                            key={index.toString() + '-item'}
                            ref={item.key}
                            changeCallback={this.onChangeValue(item.key)}
                            defaultValue={this.values[item.key] != null ? this.values[item.key] : item.defaultValue}
                            lines={4}
                            noX={true}
                            name={item.name}
                            position="input-container-sidebartab"
                        />
                    );
                    break;
                case FormularItemType.CHECK:
                    result.push(
                        <div className="custom-input-toggle-box" key={index.toString() + '-item'}>
                            <InputCheckBox
                                label={t(item.label) + (item.required ? ' *' : '')}
                                active={this.values[item.key] === true}
                                onClick={this.onChangeValueForCheckbox(item.key, true)}
                            />
                        </div>
                    );
                    break;
                case FormularItemType.SELECT:
                    if (item.values) {
                        const selectValue: string = this.values[item.key] != null ? this.values[item.key] : item.defaultValue;
                        result.push(
                            <DesktopSelect
                                className={'input-group-formular' + (selectValue != null ? ' input-group-valid' : ' input-group-invalid')}
                                options={item.values.map((value) => {
                                    return {
                                        name: t(value.label),
                                        className: 'egr-select-option-noicon',
                                        value: value.value,
                                        callback: () => { this.setValue(value.value, item.key, true); }
                                    };
                                }).filter((option) => {
                                    return option.value != null || selectValue == null;
                                })}
                                title=""
                                value={selectValue}
                                id={item.key}
                                key={index.toString() + '-item'}
                            />
                        );
                    }
                    break;
                case FormularItemType.CHECKRADIO:
                    if (item.values) {
                        result.push(
                            <CustomRadioGroup
                                label={t(item.label) + (item.required ? ' *' : '')}
                                values={item.values.map((value: { label: string, value: string }) => {
                                    return { label: t(value.label) as string, value: value.value };
                                })}
                                onChange={this.onChangeValue(item.key, true)}
                                type="checkbox"
                                key={index.toString() + '-item'}
                            />
                        );
                    }
                    break;
                case FormularItemType.CHECKRADIOGROUP:
                    if (item.values) {
                        result.push(
                            <CustomCheckRadioGroup
                                label={t(item.label) + (item.required ? ' *' : '')}
                                values={item.values.map((value: { label: string, value: string }) => {
                                    return { label: t(value.label) as string, value: value.value };
                                })}
                                onChange={this.onChangeValue(item.key, true)}
                                type="radio"
                                key={index.toString() + '-item'}
                                defaultValue={item.defaultValue}
                                value={this.values[item.key] as string}
                            />
                        );
                    }
                    break;
                default:
                    break;
            }
        });
        return result;
    };

    protected async generateAndSendMail(captchaToken: string | undefined, killProcess: () => boolean): Promise<void> {
        if (killProcess()) {
            return;
        }

        await ArticleActions.updateArticleList();

        if (killProcess()) {
            return;
        }

        GlobalHelper.coreApp.document.appData.setData('contactform', 'choice', [
            'Ich möchte weitere Produktinformationen erhalten',
            'Ich möchte ein Angebot und/oder eine Beratung erhalten',
            'Ich möchte weitere Produktinformationen und ein Angebot/eine Beratung erhalten'
        ][this.state.choice]);
        for (let i: number = 0, keys: Array<string> = Object.keys(this.values); i < keys.length; i++) {
            GlobalHelper.coreApp.document.appData.setData('contactform', keys[i], this.values[keys[i]]);
        }
        const pboxUrl: string = await DownloadHelper.exportPBox();

        if (killProcess()) {
            return;
        }

        GlobalHelper.coreApp.document.appData.setData('contactform', 'choice', undefined);
        for (let i: number = 0, keys: Array<string> = Object.keys(this.values); i < keys.length; i++) {
            GlobalHelper.coreApp.document.appData.setData('contactform', keys[i], undefined);
        }
        const reopenUrl: string = UrlHelper.getCurrentLink({
            queryArguments: {
                pbox: pboxUrl
            },
            hashArguments: {}
        });

        const filename: string = ProjectManagerStore.getProjectName(true);
        let pdfUrl: string = await PDFMaker.generatePDFAsBase64();
        pdfUrl = await DownloadHelper.uploadContentToFileStorage(pdfUrl, filename, 'pdf');

        if (killProcess()) {
            return;
        }

        const obkUrl: string = await DownloadHelper.exportObk();

        if (killProcess()) {
            return;
        }

        const obkContent: ArrayBuffer = await DownloadHelper.getContent(obkUrl);

        if (killProcess()) {
            return;
        }

        let manufacturerMail: string = [
            [
                'Ich möchte weitere Produktinformationen erhalten',
                'Ich möchte ein Angebot und/oder eine Beratung erhalten',
                'Ich möchte weitere Produktinformationen und ein Angebot/eine Beratung erhalten'
            ][this.state.choice],
            '',
            'Link zur Planung: ',
            reopenUrl,
            '',
            'Link zur Artikelliste: ',
            pdfUrl,
            '',
            'Kontaktinfo:'
        ].join('\n');

        for (const formField in this.config) {
            if (this.values.hasOwnProperty(formField)) {
                // tslint:disable-next-line:max-line-length
                let value: string | number = '';
                if (this.values[formField]) {
                    if (formField === 'i-am-a' || formField === 'information-by') {
                        value = t(this.values[formField] as string);
                    } else if (typeof this.values[formField] === 'boolean') {
                        value = this.values[formField] ? t('Yes', { lng: 'de' }) : t('No', { lng: 'de' });
                    } else {
                        value = this.values[formField] as string | number;
                    }
                }
                manufacturerMail += `\n${this.config[formField].labelManufacturerMail}: ${value}`;
            }
        }

        const obkInfo: FileFormatInfo = FileFormats.OBK;
        const message: Message = {
            subject: t('Contact request', { lng: 'de' }),
            textContent: manufacturerMail,
            captchaToken: captchaToken,
            attachments: [
                {
                    filename: 'session.' + obkInfo.extension,
                    mimetype: obkInfo.mimetype,
                    content: obkContent
                }
            ],
            to: [this.values.email as string]
        };

        Stats.sendEvent({
            action: 'Email'
        });

        await MailPlugin.sendMessage('manufacturermail', message);
        // await MailPlugin.sendMessage('dynamic_mail', message);
    }

    protected submitCleverreach(): void {
        if (
            this.values['information-by'] !== 'By e-mail' &&
            this.values['information-by'] !== 'By e-mail and by phone'
        ) {
            return;
        }
        const form: HTMLFormElement = document.createElement('form');
        form.target = '_blank';
        form.action = 'https://eu2.cleverreach.com/f/197828-232646/wcs/';
        form.method = 'post';
        form.style.display = 'none';

        for (const fieldname in this.config) {
            if (this.config.hasOwnProperty(fieldname)) {
                const fielditem: FormularItem = this.config[fieldname];
                if (fielditem.cleverreachName == null) {
                    continue;
                }
                const input: HTMLInputElement = document.createElement('input');
                input.name = fielditem.cleverreachName;
                switch (fielditem.type) {
                    case FormularItemType.CHECKRADIO:
                        input.name = fielditem.cleverreachName + '[]';
                        input.value = t(this.values[fieldname] as string, { lng: 'de' });
                        break;
                    default:
                        input.name = fielditem.cleverreachName;
                        input.value = this.values[fieldname] as string;
                        break;
                }
                form.appendChild(input);
            }
        }

        document.body.appendChild(form);
        form.submit();
    }

    protected submit = async (): Promise<void> => {
        this.submitCleverreach();
        let resolveFromOutside: () => void;
        let killPromise: boolean = false;
        const keepAliveCheck: () => boolean = () => {
            return killPromise;
        };

        const mailCreatingPromise: Promise<void> = new Promise<void>((resolve, reject) => {
            resolveFromOutside = resolve;
            return this.generateAndSendMail(this.state.token, keepAliveCheck).then(resolve).catch(reject);
        });

        await ViewSettingsActions.withLock<void>(
            () => { return mailCreatingPromise; },
            <LoadingCancelable cancelCallback={() => { resolveFromOutside(); killPromise = true; }} label={t('Processing')}/>
        ).then(() => {
            this.resetRecaptcha();
            UIHelper.showMessage(t('Many thanks for your inquiry. Our employees will process your request as soon as possible.'), () => {
                ViewSettingsActions.changeSidebar(SidebarModule.NONE);
            });
        }).catch(() => {
            this.resetRecaptcha();
        });
    };
    protected firstStep = (): void => {
        this.setState({
            ...this.state,
            step: 1
        });
    };

    protected nextStep = (): void => {
        Object.keys(this.config).forEach((key) => {
            this.config[key].required = key === 'email' || (
                this.state.choice !== 0 && (
                    key === 'name' ||
                    key === 'street' ||
                    key === 'postalcode' ||
                    key === 'city' ||
                    key === 'country'
                )
            );
        });
        switch (this.state.choice) {
            case 0:
                Stats.sendEvent({
                    action: 'ProdInfo'
                });
                break;
            case 1:
                Stats.sendEvent({
                    action: 'Angebot'
                });
                break;
            case 2:
                Stats.sendEvent({
                    action: 'AngProd'
                });
                break;
            default:
                break;
        }
        this.setState({
            ...this.state,
            step: 2
        });
    };

    protected openShareMail = (): void => {
        ViewSettingsActions.changeSidebar(SidebarModule.SHARE_MAIL);
    };

    protected setChoice = (value: string): void => {
        this.setState({
            ...this.state,
            choice: parseInt(value, 10)
        });
    };

    protected onRecaptchaChange = (token?: string): void => {
        this.setState({ token });
    };

    protected resetRecaptcha = (): void => {
        if (this.recaptcha != null) {
            this.recaptcha.reset();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/CustomShareFormular.tsx